const financialClassIndex = {
  0: "Medicare",
  1: "Medicaid",
  2: "Commercial",
  3: "Self Pay",
  4: "Blue Cross",
}

const stages = [
  { ID: 0, Name: "Charge Entry" },
  { ID: 1, Name: "Eligibility" },
  { ID: 2, Name: "Modifier" },
  { ID: 3, Name: "AMD Output" },
  { ID: 4, Name: "Diagnosis Validity" },
  { ID: 5, Name: "Hold" },
  { ID: 6, Name: "Implode Stage" },
  { ID: 7, Name: "Event Output" },
  { ID: 9, Name: "Blue Cross Routing" },
]

const stageIndex =
{
  0: "Charge Entry",
  1: "Eligibility",
  2: "Modifier",
  3: "AMD Output",
  4: "Diagnosis Validity",
  5: "Hold",
  6: "Implode Stage",
  7: "Event Output",
  9: "Blue Cross Routing",
}


export { financialClassIndex, stages, stageIndex };
